import Vue from 'vue'
import App from './App.vue'
import './plugins/base'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store'
import axios from 'axios'

 Vue.prototype.$hostname = 'https://pceportall10.foxconn.com/'
 Vue.prototype.$SAPAPI= 'https://pceportall10.foxconn.com/sap/'

//Vue.prototype.$hostname = 'http://localhost:1546/'
//Vue.prototype.$SAPAPI= 'http://10.13.7.145:1101/'

//Vue.prototype.$hostname = 'http://10.13.8.213:843/'
//axios.defaults.baseURL = 'http://10.13.8.213:843/'

Vue.config.productionTip = false

//axios.defaults.baseURL = 'http://localhost:t/'
//Vue.prototype.$hostname = 'http://localhost:1546'

//http://10.13.25.57:80/

//axios.defaults.baseURL = 'http://68.64.233.15:843/'
new Vue({
  router,   
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
